import { render, staticRenderFns } from "./MedicationAdministration.vue?vue&type=template&id=5ae72c36"
import script from "./MedicationAdministration.vue?vue&type=script&lang=js"
export * from "./MedicationAdministration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports